var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"offcanvas-lg offcanvas-start",attrs:{"id":"product-filter","tabindex":"-1"}},[_c('BrandFilterContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }